import { actionCreator } from '@ardoq/rxbeach';
import { APISlideAttributes, ArdoqId } from '@ardoq/api-types';
import { type SlideNavigatorState } from './types';

export const selectSlide = actionCreator<ArdoqId | null>(
  '[slideNavigator] Select slide'
);

export const nextSlide = actionCreator('[slideNavigator] Next slide');

export const previousSlide = actionCreator('[slideNavigator] Previous slide');

export const backToSlide = actionCreator('[slideNavigator] Back to slide');

export const toggleSlideOverview = actionCreator(
  '[slideNavigator] Toggle slide overview'
);

export const closeSlideOverview = actionCreator(
  '[slideNavigator] Close slide overview'
);

export const setIsDescriptionExpanded = actionCreator<boolean>(
  '[slideNavigator] Set is description expanded'
);

export const setIsNodeDescriptionExpanded = actionCreator<boolean>(
  '[slideNavigator] Set is node description expanded'
);

export const setIsNavigatorDismissed = actionCreator<boolean>(
  '[slideNavigator] Set is navigator dismissed'
);

export const navigatorTourStarted = actionCreator(
  '[slideNavigator] Navigator tour started'
);

export const setSlideDescription = actionCreator<ArdoqId>(
  '[slideNavigator] Show slide description'
);

export const setNodeDescription = actionCreator<{
  name: string;
  description: string;
}>('[slideNavigator] Show node description');

export const selectNodeInPresentationMode = actionCreator<ArdoqId>(
  '[slideNavigator] Select node'
);

export const setSlideNavigatorState = actionCreator<
  Partial<SlideNavigatorState>
>('[slideNavigator] Set state');

export const reloadCurrentSlide = actionCreator(
  '[slideNavigator] Reload slide'
);

export const loadSlides = actionCreator<APISlideAttributes[]>(
  '[slides] LOAD_SLIDES'
);
